// Default rules seeded from Sir's Pine Script: SMC + OB Fib 0.5 Zones (v1)
// Each rule has a stable seed_id so it is never duplicated on app reload.

export const DEFAULT_RULES = [
  {
    seed_id:     'RULE_OB_FIB05_BUY',
    title:       'Bullish OB Fib 0.5 — BUY Zone Entry',
    ict_concept: 'Order Block + Fib 0.5',
    condition:   'Price enters the LOWER HALF of an unmitigated Bullish Order Block (at or below the OB midpoint = 0.5 Fib of OB range). BOS already confirmed in bullish direction.',
    action:      'BUY',
    session:     'London, New York',
    htf_bias:    'BULLISH',
    sl_method:   'Below the Bullish OB low (1–3 pips below OB bottom)',
    tp_method:   'Next liquidity pool above (EQH / previous swing high / BSL)',
    rr_minimum:  2,
    source:      'Pine Script — SMC + OB Fib 0.5 Zones',
    notes:       'OB Fib 0.5 = (OB High + OB Low) / 2. Enter at or below midpoint for best RR. Blue zone on chart. Skip if OB candle range > 2x ATR(200) (high-volatility bar). Only trade UNMITIGATED OBs.',
  },
  {
    seed_id:     'RULE_OB_FIB05_SELL',
    title:       'Bearish OB Fib 0.5 — SELL Zone Entry',
    ict_concept: 'Order Block + Fib 0.5',
    condition:   'Price enters the UPPER HALF of an unmitigated Bearish Order Block (at or above the OB midpoint = 0.5 Fib of OB range). BOS already confirmed in bearish direction.',
    action:      'SELL',
    session:     'London, New York',
    htf_bias:    'BEARISH',
    sl_method:   'Above the Bearish OB high (1–3 pips above OB top)',
    tp_method:   'Next liquidity pool below (EQL / previous swing low / SSL)',
    rr_minimum:  2,
    source:      'Pine Script — SMC + OB Fib 0.5 Zones',
    notes:       'OB Fib 0.5 = (OB High + OB Low) / 2. Enter at or above midpoint for best RR. Red zone on chart. Skip if OB candle range > 2x ATR(200) (high-volatility bar). Only trade UNMITIGATED OBs.',
  },
  {
    seed_id:     'RULE_BOS_CONTINUATION',
    title:       'BOS = Trend Continuation — Trade With the Break',
    ict_concept: 'Break of Structure (BOS)',
    condition:   'A confirmed BOS occurs (price breaks and closes beyond the previous swing high for bullish / swing low for bearish) with internal structure aligned.',
    action:      'BUY on bullish BOS / SELL on bearish BOS',
    session:     'Any',
    htf_bias:    'Same direction as BOS',
    sl_method:   'Below last swing low (bullish BOS) / above last swing high (bearish BOS)',
    tp_method:   'Next major liquidity pool in BOS direction',
    rr_minimum:  2,
    source:      'Pine Script — SMC + OB Fib 0.5 Zones',
    notes:       'BOS = smart money commitment to the current trend. Internal BOS (5-bar structure) = early signal. Swing BOS (50-bar) = major confirmation. Wait for price to return to an OB in BOS direction for entry — do not chase.',
  },
  {
    seed_id:     'RULE_CHOCH_CONFIRMATION',
    title:       'CHoCH = First Reversal Warning — Wait for Confirmation',
    ict_concept: 'Change of Character (CHoCH)',
    condition:   'A CHoCH appears (price breaks the most recent internal swing in the opposite direction of the current trend). This is the FIRST WARNING only.',
    action:      'WAIT — Do NOT enter on CHoCH alone. Wait for a BOS in the new direction OR a tap of a fresh OB in the new direction.',
    session:     'Any',
    htf_bias:    'Potential reversal',
    sl_method:   'Confirm after second signal',
    tp_method:   'Confirm after second signal',
    rr_minimum:  2,
    source:      'Pine Script — SMC + OB Fib 0.5 Zones',
    notes:       'CHoCH = Change of Character. It is a WARNING not a signal. The sequence for a reversal trade: CHoCH → BOS in new direction → OB tap in new direction → ENTRY. Never skip confirmation steps.',
  },
  {
    seed_id:     'RULE_HIGH_VOL_BAR_SKIP',
    title:       'High-Volatility Bar — Skip as Order Block',
    ict_concept: 'ATR Filter + OB Validity',
    condition:   'Candle range (High - Low) is greater than 2x ATR(200). This candle appears to be an "Order Block" candidate.',
    action:      'SKIP — Do not mark this candle as a valid Order Block. Wait for the next qualifying candle.',
    session:     'Any',
    htf_bias:    'Any',
    sl_method:   'N/A',
    tp_method:   'N/A',
    rr_minimum:  2,
    source:      'Pine Script — SMC + OB Fib 0.5 Zones',
    notes:       'High-volatility bars represent news/panic candles — not true institutional order flow. ATR(200) gives the "normal" candle range baseline. A candle > 2x that baseline is too volatile to be a reliable OB entry zone.',
  },
  {
    seed_id:     'RULE_EQH_EQL_LIQUIDITY',
    title:       'EQH / EQL — Liquidity Sweep Before Entry',
    ict_concept: 'Liquidity + Stop Hunt',
    condition:   'Equal Highs (EQH) or Equal Lows (EQL) visible on chart — representing a cluster of stops above/below.',
    action:      'ANTICIPATE a sweep of EQH/EQL before the real move. After the sweep (stop hunt), look for an OB entry in the opposite direction.',
    session:     'London Open, NY Open',
    htf_bias:    'Opposite of liquidity pool direction',
    sl_method:   'Beyond the swept level (if trading the reversal)',
    tp_method:   'Previous OB or swing high/low on the other side',
    rr_minimum:  2,
    source:      'Pine Script — SMC + OB Fib 0.5 Zones',
    notes:       'EQH = Equal Highs = buy-side liquidity (stops sitting above). Smart money will grab these stops before reversing. EQL = Equal Lows = sell-side liquidity. The SWEEP is the signal — enter AFTER the sweep wick closes back inside the range, not before.',
  },
];
